module.exports = __webpack_public_path__ + "static/img/89.f6d79fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/news/gallery/24/89.jpg
// module id = 747
// module chunks = 0